export const CSSMediaSize = {
  phone_small: '@media only screen and (max-width: 400px)',
  phone: '@media only screen and (max-width: 600px)',
  phone_big: '@media only screen and (max-width: 768px)',
  tablet: '@media only screen and (max-width: 992px)',
  pc_small: '@media only screen and (max-width: 1366px)',
  pc: '@media only screen and (max-width: 1440px)',
  pc_big: '@media only screen and (max-width: 1536px)',
  pc_huge: '@media only screen and (max-width: 1600px)',
};

export enum MouseButton {
  Left = 0,
  Middle = 1,
  Right = 2,
  Back = 3,
  Forward = 4,
}
